import { Dispatch, SetStateAction, useEffect, useState } from 'react';

type TUseSelectedFilter = (args: {
  initialFilter?: number;
}) => [number, Dispatch<SetStateAction<number>>];

export const useSelectedFilter: TUseSelectedFilter = args => {
  const { initialFilter } = args;

  const [selected, setSelected] = useState(0);

  useEffect(() => {
    if (initialFilter) {
      setSelected(initialFilter);
    }
  }, [initialFilter]);

  return [selected, setSelected];
};
